import SearchRequest from "@/api/dataSource/api/Spirit/Common/Extensions/Models/SearchRequest";
import IFilterModel from "../IFilterModel";
import moment from "moment";
import SearchLevelRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Level/SearchLevelRequest";



export class LevelFilterModel implements IFilterModel {
    search: string = '';
    dateFrom: Date = null;
    dateTo: Date = null;

    resetToDefault() {
        this.search = '';
        this.dateFrom = null;
        this.dateTo = null;
    }

    toSearchRequest(): SearchRequest[] {
        const res = new Array<SearchRequest>();
        if (this.dateFrom) {
        const range = new SearchRequest({FieldName: 'Created', SearchFrom: moment(this.dateFrom).format('YYYY-MM-DD')});
            res.push(range);
            if (this.dateTo) {
                range.SearchTo = moment(this.dateTo).format('YYYY-MM-DD');
            }
        }
        return res;
    }

    toFilterRequest(): SearchLevelRequest {
        const res = new SearchLevelRequest({
            Name: this.search
        });

        res.Search = this.toSearchRequest();
        return res;
    }
}